import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { UserButton } from '../../../../components/appbar/user-button/user-button'
import { LanguageControlType, LanguageSelector } from '../../../../components/appbar/language'
import { AdminFeature } from '../../types'
import { useFeature } from '../../hooks'
import { useTypedTranslation } from 'app/modules/shared/hooks/use-translation'
import { AuthContext } from 'app/modules/auth'
import { Feature } from 'app/modules/auth/types'
import { allowedFeaturesStorage } from 'app/modules/auth/helper/storage'
import { getActiveRouteClass } from 'app/components/appbar/helpers/helpers'
import { getPageUrl } from 'app/modules/shared/routing'
import AppbarLayout from 'app/components/layouts/appbar-layout'

interface FeatureData {
  name: string
  pageKey: string
  icon: string
  skip?: boolean
  feature: AdminFeature
}

export const AdminAppbar = (): JSX.Element => {
  const { _t } = useTypedTranslation()
  const { user } = useContext(AuthContext)
  const feature = useFeature()
  const allowedFeatures = allowedFeaturesStorage.getFeatures()
  const getActiveMenuClass = (url: string) => getActiveRouteClass([url], feature as string, 'appbar-item-selected')

  const features: FeatureData[] = [
    {
      name: _t('stat'),
      pageKey: 'admin-stat-home',
      icon: 'ds3-icon ds3-stat',
      feature: AdminFeature.Stat,
    },
    {
      name: _t('user-management'),
      pageKey: 'admin-user-management-home',
      icon: 'ds3-icon ds3-user-group',
      skip: user?.isAuditor,
      feature: AdminFeature.UserManagement,
    },
    {
      name: _t('jobs'),
      pageKey: 'admin-jobs-home',
      icon: 'ds3-icon ds3-server',
      feature: AdminFeature.Jobs,
    },
    {
      name: _t('settings'),
      pageKey: 'admin-settings-home',
      icon: 'ds3-icon ds3-settings',
      skip: user?.isAuditor,
      feature: AdminFeature.Settings,
    },
    {
      name: _t('scan-sources'),
      pageKey: 'admin-scan-sources-home',
      icon: 'ds3-icon ds3-laptop',
      skip: user?.isAuditor,
      feature: AdminFeature.ScanSources,
    },
    {
      name: _t('audit-logger'),
      pageKey: 'admin-audit-logger-home',
      icon: 'ds3-icon ds3-search',
      feature: AdminFeature.AuditLogger,
    },
    {
      name: _t('leads'),
      pageKey: 'admin-leads-home',
      icon: 'ds3-icon ds3-user-group',
      // Lead management is AND-evaluated server-side (auditor + lead_manager,
      // or admin), so the allowed-features list is the single source of truth
      // for whether this entry is shown.
      skip: !allowedFeatures?.includes(Feature.Lead_management),
      feature: AdminFeature.Leads,
    },
  ]

  return (
    <AppbarLayout isAdmin>
      {features.map((featureLink) => {
        if (featureLink.skip) {
          return null
        }

        return (
          <Link
            key={featureLink.pageKey}
            className={`appbar-item nav-link ${getActiveMenuClass(featureLink.feature)}`}
            to={getPageUrl(featureLink.pageKey) as string}
          >
            <i className={`${featureLink.icon} me-2`} />
            <span>{featureLink.name}</span>
          </Link>
        )
      })}

      <div className="my-auto appbar-divider" />
      <LanguageSelector type={LanguageControlType.Button} />
      {/* <Notifications />  - To be added in phase 2*/}
      <UserButton />
    </AppbarLayout>
  )
}
